import React from 'react';
import classes from './MainButton.module.scss';
import colors from '../../../scss/colors';
import { buttonVariants } from './types';

export default function MainButton(props) {
  const {
    size = 'small',
    variant = buttonVariants.PRIMARY,
    outlined = false,
    rounded = false,
    action,
    forceWidth,
    disabled,
    children
  } = props;

  const sizes = {
    xsmall: classes.xsmall,
    small: classes.small,
    medium: classes.medium
  };

  const roundedBySize = {
    xsmall: '30px',
    small: '40px',
    medium: '56px'
  };

  const variants = {
    primary: {
      text: colors.NAVY_BLUE,
      border: colors.NAVY_BLUE,
      background: 'linear-gradient(180deg, rgba(0, 73, 118, 0) 0%, #004876 100%), #009ACE'
    },
    secondary: {
      text: colors.NAVY_BLUE,
      border: colors.NAVY_BLUE,
      background: colors.WHITE
    },
    ternary: {
      text: colors.DARKEST_GREY,
      border: colors.DARKEST_GREY,
      background: colors.WHITE
    },
    selected: {
      text: colors.WHITE,
      border: colors.NAVY_BLUE,
      background: colors.NAVY_BLUE
    },
    disabled: {
      text: `${colors.MEDIUM_GREY}90`,
      border: `${colors.MEDIUM_GREY}90`,
      background: `${colors.MEDIUM_GREY}90`
    }
  };

  const getVariants = (variantType, isOutlined) => {
    if (isOutlined) {
      return {
        background: 'white',
        color: variants[variantType].text,
        border: `1px solid${variants[variantType].border}`,
        opacity: variants[variantType].opacity
      };
    }

    return {
      background: variants[variantType].background,
      color: 'white'
    };
  };

  return (
    <button
      className={`${classes.basic} ${sizes[size]}`}
      style={{
        ...getVariants(variant, outlined),
        borderRadius: rounded ? roundedBySize[size] : '5px',
        width: forceWidth || 'fit-content'
      }}
      disabled={disabled}
      onClick={action}
    >
      {children}
    </button>
  );
}
